export const SET_SIDEBAR_POPUP = 'set_sidebar_popup';

export const APP_INITIAL_STATE = {
	app: {
		showSidebar: false
	}
};
